import { render, staticRenderFns } from "./NoDataContainer.vue?vue&type=template&id=52c99d5c&scoped=true&"
import script from "./NoDataContainer.vue?vue&type=script&lang=js&"
export * from "./NoDataContainer.vue?vue&type=script&lang=js&"
import style0 from "./NoDataContainer.vue?vue&type=style&index=0&id=52c99d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c99d5c",
  null
  
)

export default component.exports